export const dynatraceViewSample = {
    'ImpactedEntities': [{
        'type': 'HOST',
        'name': 'ip-10-251-33-138.ap-northeast-2.compute.internal',
        'entity': 'HOST-5A2190BBA5B0E0F2'
    }],
    'ImpactedEntity': '3 infrastructure problems on 3 Infrastructure components',
    'PID': '-5538799181360376970',
    'ProblemDetailsHTML': 'OPEN Problem 970 in environment <i>bca12352</i>',
    'ProblemDetailsJSON': {
        'id': '-5538799181360376970',
        'startTime': 1575011545268,
        'endTime': -1,
        'displayName': '970',
        'impactLevel': 'INFRASTRUCTURE',
        'status': 'OPEN',
        'severityLevel': 'AVAILABILITY',
        'commentCount': 0,
        'tagsOfAffectedEntities': [],
        'rankedEvents': [{
            'startTime': 1575011545268,
            'endTime': -1,
            'entityId': 'HOST-5A2190BBA5B0E0F2',
            'entityName': 'ip-10-251-33-138.ap-northeast-2.compute.internal',
            'severityLevel': 'AVAILABILITY',
            'impactLevel': 'INFRASTRUCTURE',
            'eventType': 'HOST_GRACEFULLY_SHUTDOWN',
            'status': 'OPEN',
            'severities': [],
            'isRootCause': true
        }],
        'rankedImpacts': [{
            'entityId': 'HOST-5A2190BBA5B0E0F2',
            'entityName': 'ip-10-251-33-138.ap-northeast-2.compute.internal',
            'severityLevel': 'AVAILABILITY',
            'impactLevel': 'INFRASTRUCTURE',
            'eventType': 'HOST_GRACEFULLY_SHUTDOWN'
        }],
        'affectedCounts': {
            'INFRASTRUCTURE': 3,
            'SERVICE': 0,
            'APPLICATION': 0,
            'ENVIRONMENT': 0
        },
        'recoveredCounts': {
            'INFRASTRUCTURE': 0,
            'SERVICE': 0,
            'APPLICATION': 0,
            'ENVIRONMENT': 0
        },
        'hasRootCause': true
    },
    'ProblemDetailsMarkdown': '## OPEN Problem 970 in environment',
    'ProblemDetailsText': 'OPEN Problem 970 in environment',
    'ProblemID': '970',
    'ProblemImpact': 'INFRASTRUCTURE',
    'ProblemSeverity': 'AVAILABILITY',
    'ProblemTitle': '3 infrastructure problems',
    'ProblemURL': 'https://bca12352.live.dynatrace.com/#problems/problemdetails;pid=-5538799181360376970',
    'State': 'OPEN',
    'Tags': ''
};

export const dynatraceSample = {
    'ImpactedEntities[].type': 'HOST',
    'ImpactedEntities[].name': 'ip-10-251-33-138.ap-northeast-2.compute.internal',
    'ImpactedEntities[].entity': 'HOST-5A2190BBA5B0E0F2',
    'ImpactedEntity': '3 infrastructure problems on 3 Infrastructure components',
    'PID': '-5538799181360376970',
    'ProblemDetailsJSON.startTime': '1575011545268',
    'ProblemDetailsJSON.endTime': '-1',
    'ProblemDetailsJSON.displayName': '970',
    'ProblemDetailsJSON.impactLevel': 'INFRASTRUCTURE',
    'ProblemDetailsJSON.status': 'OPEN',
    'ProblemDetailsJSON.severityLevel': 'AVAILABILITY',
    'ProblemDetailsJSON::rankedEvents[].entityId': 'HOST-5A2190BBA5B0E0F2',
    'ProblemDetailsJSON::rankedEvents[].entityName': 'ip-10-251-33-138.ap-northeast-2.compute.internal',
    'ProblemDetailsJSON::rankedEvents[].eventType': 'HOST_GRACEFULLY_SHUTDOWN',
    'ProblemDetailsText': 'EN Problem 970 in environment bca12352\\nProblem detected at: 07:12 (UTC) 29.11.2019\\n\\n3 impacted infrastructure components\\n\\nProcess\\nApache Web Server apache*\\n\\nProcess unavailable\\nProcess Apache Web Server apache* on host ip-10-251-33-138.ap-northeast-2.compute.internal has been shut down\\n\\nProcess\\nnginx\\n\\nProcess unavailable\\nProcess nginx on host ip-10-251-33-138.ap-northeast-2.compute.internal has been shut down\\n\\nRoot cause\\n\\nHost\\nip-10-251-33-138.ap-northeast-2.compute.internal\\n\\nHost unavailable\\nHost ip-10-251-33-138.ap-northeast-2.compute.internal has been shut down\\n\\nOSI_GRACEFULLY_SHUTDOWN\\nip-10-251-33-138.ap-northeast-2.compute.internal - OSI_GRACEFULLY_SHUTDOWN\\n\\nhttps://bca12352.live.dynatrace.com/#problems/problemdetails;pid=-5538799181360376970',
    'ProblemID': '970',
    'ProblemImpact': 'INFRASTRUCTURE',
    'ProblemSeverity': 'AVAILABILITY',
    'State': 'OPEN'
};



// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/dynatrace.ts